<template>
  <div class="invitee-item columns">
    <div class="invitee-photo column is-1">
      {{ initials }}
    </div>
    <div class="invitee-details column">
      <div class="invitee-name">{{ name }}</div>
      <div class="invitee-email">{{ email }}</div>
    </div>
    <div class="column is-1">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { reduce } from 'lodash';

export default {
  data: () => ({
    photo_url: 'none.jpeg',
  }),

  props: {
    name: String,
    email: String,
  },

  computed: {
    initials() {
      return reduce(this.name.split(' '), (value, name) => `${value}${name.charAt(0).toUpperCase()}`, '');
    },
  },
};
</script>

<style lang="scss" scoped>
  .invitee-name {
    font-size: 14px;
    font-weight: bold;
  }

  .invitee-photo {
    margin-right: 20px;
  }

  .invitee-item {
    border-bottom: 1px solid #E8E8E8;
    padding: 5px 0px;
    display: flex;
  }
</style>




// WEBPACK FOOTER //
// src/components/Booking/Invites/Item.vue